module.exports = __webpack_public_path__ + "static/media/favorite.996a57a8.svg";